import { useParams } from 'react-router-dom';
import { useAbortableEffect } from '@round/utils';
import { useMicrosPaymentRequest } from './useMicrosPaymentRequest';
import FormSubmitted from './FormSubmitted/FormSubmitted';
import { FormClosed, FormError, FormLinkBroken } from './FormIssues/FormIssues';
import FormLoading from './FormLoading/FormLoading';
import FormOpen from './FormOpen/FormOpen';

const MicrosPaymentRequest = () => {
    const { uuid } = useParams();

    const { init, status, data, updateFormData } = useMicrosPaymentRequest(uuid);

    useAbortableEffect(
        (signal) => {
            if (status === 'NOT_INITIALIZED') {
                init({ signal });
            }
        },
        [init, status]
    );

    return (
        <>
            {status === 'NOT_INITIALIZED' ? (
                <FormLoading />
            ) : status === 'ERROR' || !data ? (
                <FormError />
            ) : status === 'LINK_BROKEN' || !uuid ? (
                <FormLinkBroken />
            ) : status === 'FORM_CLOSED' ? (
                <FormClosed />
            ) : status === 'FORM_SUBMITTED' ? (
                <FormSubmitted data={data} />
            ) : (
                status === 'FORM_OPEN' && <FormOpen data={data} uuid={uuid} onSuccess={updateFormData} />
            )}
        </>
    );
};

export default MicrosPaymentRequest;
